export enum CpaToolsIntegrationStatus {
  CreateRejected = 'create-rejected',
  CreateStarted = 'create-started',
  CreateSuccess = 'create-success',
}
